//import Vue from 'vue';
//import {TOKENENDPOINT, APIENDPOINT, getHeader,ENV } from './app.config';
import axios from "axios";

//const OAUTH =ENV.OAUTH;
export default {
  login(value, cb) {
    return new Promise(function(resolve, reject) {
      axios
        .post(process.env.VUE_APP_SEGURIDAD + "/auth/login", value)
        .then(function(res) {
          resolve(res.data);
        })
        .catch(function(err) {
          reject(err.response.data);
        });
    });
  },

  token(code, redirect_uri, cb) {
    var data = new FormData();
    data.set("grant_type", "authorization_code");
    data.set("redirect_uri", redirect_uri);
    data.set("code", code);
    return new Promise(function(resolve, reject) {
      axios
        .post(process.env.VUE_APP_SEGURIDAD + "/oauth/token", data, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization:
              "Basic " +
              btoa(
                process.env.VUE_APP_URL_OAUTH_ID +
                  ":" +
                  process.env.VUE_APP_URL_OAUTH_PASSWORD
              ),
          },
        })
        .then(function(res) {
          res.status = "success";
          resolve(res);
        })
        .catch(function(err) {
          reject(err);
        });
    });
  },

  user(token_user) {
    //let auth = getHeader();

    let auth = function() {
      const tokenData = JSON.parse(window.localStorage.getItem("geodir_Token"));
      const headers = {
        Accept: "application/json",
        Authorization: "Bearer " + tokenData.data.access_token,
      };
      return headers;
    };
    /*return new Promise(function (resolve, reject) {

            axios.get(process.env.VUE_APP_SEGURIDAD + '.api/profile/me',{headers:auth}).then(function (res) {
                res.status = "success";
                resolve(res);
            }).catch(function (err) {
                console.log('LOGIN SERVICE ERROR');
                console.log(err);
                reject(err)
            })
        });*/

    return new Promise(function(resolve, reject) {
      //axios.get(process.env.VUE_APP_SEGURIDAD + '.api/profile/me',{

      console.log("obtener token");
      console.log();

      axios
        .get(process.env.VUE_APP_SEGURIDAD_INFOUSER + "/profile/me", {
          headers: {
            "Content-Type": "application/json; charset=utf-8",
            Authorization: "bearer " + token_user,
          },
        })
        .then(function(res) {
          console.log("resultado");

          console.log(res);

          res.status = "success";

          resolve(res);
        })
        .catch(function(err) {
          console.log("LOGIN SERVICE ERROR");
          console.log(err);
          reject(err);
        });
    });
  },
};
